import ReviewsListInfoQueryBase from "@apps/reviews/queries/ReviewsListInfoQueryBase";

class ReviewsListInfoQuery extends ReviewsListInfoQueryBase {}

export default ReviewsListInfoQuery;
